import { Section, SubTitle } from '@/components/ArticleElement'
import { AppLayout } from '@/components/Layouts/AppLayout'
import { useLanguage } from '@/hooks/Contexts'
import { Fragment } from 'react'

const Faqs = () => {
  const {
    faqs: { titles, paragraphs },
  } = useLanguage()
  return (
    <AppLayout title='faq'>
      {titles.map((title, i) => (
        <Fragment key={i}>
          {title ? <SubTitle extraCls='mt-4 first:mt-0'>{title}</SubTitle> : null}
          {paragraphs[i] ? <Section paragraphs={paragraphs[i]} paragraphCls='mt-2' /> : null}
        </Fragment>
      ))}
    </AppLayout>
  )
}

export default Faqs
